import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Mustache from 'mustache';

const HTMLTemplate = ({
  templateUrl,
  variables = {},
}) => {
  const [template, setTemplate] = useState(``);

  useEffect(() => {
    axios.get(templateUrl, {
      timeout: 10000,
    })
      .then((res) => {
        const html = res.data;
        const output = Mustache.render(html, variables);
        setTemplate(output);
      })
      .catch(() => setTemplate(`<p> Sorry, an unexpected error has happened. Please try again later. </p>`));
  }, []);

  return (
    // eslint-disable-next-line
    <div dangerouslySetInnerHTML={{ __html: template }} />
  );
};

HTMLTemplate.propTypes = {
  templateUrl: PropTypes.string.isRequired,
  variables: PropTypes.object,
};

export default HTMLTemplate;
